import { render, staticRenderFns } from "./AdminReferralPromotions.vue?vue&type=template&id=244573dc&"
import script from "./AdminReferralPromotions.vue?vue&type=script&lang=js&"
export * from "./AdminReferralPromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('244573dc')) {
      api.createRecord('244573dc', component.options)
    } else {
      api.reload('244573dc', component.options)
    }
    module.hot.accept("./AdminReferralPromotions.vue?vue&type=template&id=244573dc&", function () {
      api.rerender('244573dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminReferralPromotions.vue"
export default component.exports